module.exports = "//public.zight.com/packs/media/images/pro@3x-81c849506343398e5abf00a42edba5d1.png";